import React, { BaseSyntheticEvent, useState } from 'react';
import { deleteSubject, Subject } from '../../api/studykit';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@dls/react-core';
import { useSnackbar } from 'notistack';
import { NotiStackAction } from '../styled/notistack-action';
import { Icon } from '@dls/react-icon';
import { ColorX11 } from '../../styling/color';
import {
  StyledDialogHeading,
  StyledDialogIconContainer,
  StyledDialogTitleForIcon,
} from '../styled/styles';

interface RemoveSubjectProps {
  subject: Subject;
  studyId: string;
  open: boolean;
  onClose: () => void;
  onRemoved: () => void;
}

export const RemoveSubjectDialog: React.FC<RemoveSubjectProps> = ({
  subject,
  open,
  onClose,
  studyId,
  onRemoved,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const onSubmit = (e: BaseSyntheticEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    deleteSubject(studyId, subject.id)
      .then(() => {
        enqueueSnackbar(`${subject.name} has been deleted! `, {
          variant: 'success',
          action: <NotiStackAction close={closeSnackbar} />,
        });
        onClose();
        onRemoved();
      })
      .catch((err: Error) => {
        console.log(err);
        enqueueSnackbar(err.message, {
          variant: 'error',
          action: <NotiStackAction close={closeSnackbar} />,
        });
      })
      .finally(() => setIsSubmitting(false));
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <StyledDialogTitleForIcon disableTypography>
        <StyledDialogIconContainer>
          <Icon name={'DeleteTrash'} size={'m'} color={ColorX11.Black} />
        </StyledDialogIconContainer>
        <StyledDialogHeading variant={'h3'}>Are you sure?</StyledDialogHeading>
      </StyledDialogTitleForIcon>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to remove the following subject?
          <br /> <br />
          {subject.name}
        </DialogContentText>
        <br />
        <DialogContentText style={{ fontWeight: 700 }}>All data will be deleted!</DialogContentText>
      </DialogContent>
      <DialogActions>
        <form onSubmit={onSubmit}>
          <Button
            disabled={isSubmitting}
            type={'button'}
            onClick={onClose}
            dls_variant={'quietEmphasis'}
          >
            Cancel
          </Button>
          <Button
            disabled={isSubmitting}
            style={{ marginLeft: `8px` }}
            type={'submit'}
            dls_variant={'signalError'}
          >
            Delete
          </Button>
        </form>
      </DialogActions>
    </Dialog>
  );
};
